/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ?
          o[k] :
          ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}

// date 代表指定的日期，格式：2022-02-13
// day 传-1表始前一天，传1表始后一天
// JS获取指定日期的前一天，后一天
export function getNextDate(date, day) {
  var dd = new Date(date);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m =
    dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  return y + "-" + m + "-" + d;
}

// date 代表指定的日期，格式：2022-02-13
// day 传-1表始前一月，传1表始后一月
// JS获取指定日期的前一月，后一月
export function getNextMonth(date, month) {
  const inDate = new Date(date);
  const y = inDate.getFullYear();
  const m = inDate.getMonth();
  return formatTime(new Date(y, m + month, 1), 'yyyy-MM-dd')
}
// date 代表指定的日期，格式：2022-02-13
// day 传-1表始前一年，传1表始后一年
// JS获取指定日期的前一年，后一年
export function getNextYear(date, year) {
  const inDate = new Date(date);
  const y = inDate.getFullYear();
  const m = inDate.getMonth();
  return formatTime(new Date(y + year, m, 1), 'yyyy-MM-dd')
}

//获取当前月最后一天日期
export function getLastDate(date) {
  const d = new Date(date);
  return formatTime(new Date(d.getFullYear(), d.getMonth() + 1, 0), 'yyyy-MM-dd');
}


//获取当前月第一天日期
export function getFirstDate(date) {
  const d = new Date(date);
  return formatTime(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
}


//对象转数组
export function arrDataFormat(data) {
  let arr = []
  Object.keys(data).forEach((m) => {
    arr.push({
      value: data[m],
      name: m
    });
  });
  return arr
}


//数组去重
export function arrDistinct(data){
  return data.filter((item, index, array) => array.indexOf(item) === index);
}
